import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import AdminLogin from '../views/admin/Login.vue'
import AdminLayout from '../views/admin/Layout.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import OpsCredits from '../views/admin/ops/Credits.vue'
import OpsOnline from '../views/admin/ops/Online.vue'
import OpsActive from '../views/admin/ops/Active.vue'
import OpsProfit from '../views/admin/ops/Profit.vue'
import OpsTest from '../views/admin/ops/Test.vue'
import AdminUsers from '../views/admin/Users.vue'
import DemandsList from '../views/admin/demands/List.vue'
import DemandsMatch from '../views/admin/demands/Match.vue'
import CreationsWorks from '../views/admin/creations/Works.vue'
import CreationsCopyright from '../views/admin/creations/Copyright.vue'
import CreationsCategories from '../views/admin/creations/Categories.vue'
import UsersSkillCategories from '../views/admin/users/SkillCategories.vue'
import UsersEnterpriseAudit from '../views/admin/users/EnterpriseCreatorAudit.vue'
import AdminFeedback from '../views/admin/Feedback.vue'
import CourseReviews from '../views/admin/CourseReviews.vue'
import AdminPoints from '../views/admin/Points.vue'
import AdminMembership from '../views/admin/Membership.vue'
import AdminPayOrders from '../views/admin/PayOrders.vue'
import AdminFaq from '../views/admin/Faq.vue'
import CmsArticles from '../views/admin/content/CmsArticles.vue'
import AdminComments from '../views/admin/comments/Comments.vue'
import CommentsBanUsers from '../views/admin/comments/BanUsers.vue'
import CommentsKeywords from '../views/admin/comments/Keywords.vue'
import TrafficCategories from '../views/admin/traffic/Categories.vue'
import TrafficProducts from '../views/admin/traffic/Products.vue'
import TrafficPromotion from '../views/admin/traffic/Promotion.vue'
import AgentsList from '../views/admin/agents/List.vue'
import AgentsApplications from '../views/admin/agents/Applications.vue'
import AgentsCommission from '../views/admin/agents/Commission.vue'
import AgentsWithdrawal from '../views/admin/agents/Withdrawal.vue'
import AgentsEarnings from '../views/admin/agents/Earnings.vue'
import AdminInvoices from '../views/admin/Invoices.vue'
import AdminSettings from '../views/admin/Settings.vue'
import SystemAdmins from '../views/admin/system/Admins.vue'
import SystemRoles from '../views/admin/system/Roles.vue'
import SystemMenus from '../views/admin/system/Menus.vue'
import SystemNotices from '../views/admin/system/Notices.vue'
import OperationLogs from '../views/admin/system/OperationLogs.vue'
import PartnerLayout from '../views/partner/Layout.vue'
import HqLayout from '../views/hq/Layout.vue'
import HqBoard from '../views/hq/Board.vue'
import HqStats from '../views/hq/Stats.vue'
import HqPartners from '../views/hq/Partners.vue'
import HqAccounts from '../views/hq/Accounts.vue'
import HqWallet from '../views/hq/Wallet.vue'
import HqEcoRecharges from '../views/hq/EcoRecharges.vue'
import HqSettlements from '../views/hq/Settlements.vue'
import HqDeposits from '../views/hq/Deposits.vue'
import HqVouchers from '../views/hq/Vouchers.vue'
import HqPointRecharges from '../views/hq/PointRecharges.vue'
import HqPolicies from '../views/hq/Policies.vue'
import HqAgreements from '../views/hq/Agreements.vue'
import HqTraining from '../views/hq/Training.vue'
import HqReports from '../views/hq/Reports.vue'
import HqProfileChanges from '../views/hq/ProfileChanges.vue'
import HqAlerts from '../views/hq/Alerts.vue'
import PartnerBoard from '../views/partner/Board.vue'
import PartnerProfile from '../views/partner/Profile.vue'
import PartnerVouchers from '../views/partner/Vouchers.vue'
import PartnerRecharge from '../views/partner/Recharge.vue'
import PartnerEco from '../views/partner/Eco.vue'
import PartnerMembers from '../views/partner/Members.vue'
import PartnerWorks from '../views/partner/Works.vue'
import PartnerLines from '../views/partner/Lines.vue'
import PartnerStatements from '../views/partner/Statements.vue'
import PartnerWithdraw from '../views/partner/Withdraw.vue'
import PartnerDownline from '../views/partner/Downline.vue'
import PartnerStaff from '../views/partner/Staff.vue'
import PartnerReports from '../views/partner/Reports.vue'
import PartnerTraining from '../views/partner/Training.vue'
import PartnerCompliance from '../views/partner/Compliance.vue'
import PartnerNotices from '../views/partner/Notices.vue'
import ChannelApply from '../views/channel/Apply.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/admin/login' },
  { path: '/channel/apply', name: 'ChannelApply', component: ChannelApply },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { adminGuest: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAdmin: true },
    redirect: '/admin/dashboard',
    children: [
      { path: 'dashboard', name: 'AdminDashboard', component: AdminDashboard, meta: { menuName: '数据仪表盘', menuCode: 'dashboard' } },
      { path: 'ops/credits', name: 'OpsCredits', component: OpsCredits, meta: { menuName: '今日积分消耗', menuCode: 'dashboard' } },
      { path: 'ops/online', name: 'OpsOnline', component: OpsOnline, meta: { menuName: '在线人数', menuCode: 'dashboard' } },
      { path: 'ops/active', name: 'OpsActive', component: OpsActive, meta: { menuName: '今日活跃人数', menuCode: 'dashboard' } },
      { path: 'ops/profit', name: 'OpsProfit', component: OpsProfit, meta: { menuName: '今日利润明细', menuCode: 'dashboard' } },
      { path: 'ops/test', name: 'OpsTest', component: OpsTest, meta: { menuName: '测试号消费明细', menuCode: 'dashboard' } },
      { path: 'users', name: 'AdminUsers', component: AdminUsers, meta: { menuName: '统一账号管理', menuCode: 'users-list' } },
      { path: 'users/skill-categories', name: 'UsersSkillCategories', component: UsersSkillCategories, meta: { menuName: '用户技能分类', menuCode: 'users-skill-categories' } },
      { path: 'users/enterprise-audit', name: 'UsersEnterpriseAudit', component: UsersEnterpriseAudit, meta: { menuName: '企业创作者审核', menuCode: 'users-enterprise-audit' } },
      { path: 'demands/list', name: 'DemandsList', component: DemandsList, meta: { menuName: '需求列表', menuCode: 'demands-list' } },
      { path: 'demands/match', name: 'DemandsMatch', component: DemandsMatch, meta: { menuName: '撮合管理', menuCode: 'demands-match' } },
      { path: 'demands/categories', redirect: '/admin/users/skill-categories' },
      { path: 'creations/works', name: 'CreationsWorks', component: CreationsWorks, meta: { menuName: '作品审核', menuCode: 'creations-works' } },
      { path: 'creations/copyright', name: 'CreationsCopyright', component: CreationsCopyright, meta: { menuName: '版权申请', menuCode: 'creations-copyright' } },
      { path: 'creations/categories', name: 'CreationsCategories', component: CreationsCategories, meta: { menuName: '作品分类', menuCode: 'creations-categories' } },
      { path: 'feedback', name: 'Feedback', component: AdminFeedback, meta: { menuName: '问题反馈', menuCode: 'feedback' } },
      { path: 'course-reviews', name: 'CourseReviews', component: CourseReviews, meta: { menuName: '课程评价', menuCode: 'course-reviews' } },
      { path: 'points', name: 'Points', component: AdminPoints, meta: { menuName: '积分管理', menuCode: 'points' } },
      { path: 'membership', name: 'Membership', component: AdminMembership, meta: { menuName: '会员套餐', menuCode: 'membership_plans' } },
      { path: 'pay-orders', name: 'PayOrders', component: AdminPayOrders, meta: { menuName: '充值记录', menuCode: 'pay_orders' } },
      { path: 'faq', name: 'FaqManage', component: AdminFaq, meta: { menuName: '常见问题', menuCode: 'faq_manage' } },
      { path: 'content/news', name: 'ContentNews', component: CmsArticles, meta: { menuName: '资讯管理', menuCode: 'content-news', cmsType: 1 } },
      { path: 'content/tutorial', name: 'ContentTutorial', component: CmsArticles, meta: { menuName: '教程管理', menuCode: 'content-tutorial', cmsType: 2 } },
      { path: 'content/training', name: 'ContentTraining', component: CmsArticles, meta: { menuName: '培训材料', menuCode: 'content-training', cmsType: 4 } },
      { path: 'comments/banned', name: 'CommentsBanned', component: AdminComments, meta: { menuName: '被封禁评论', menuCode: 'comments-banned-comments' } },
      { path: 'comments/users', name: 'CommentsUsers', component: CommentsBanUsers, meta: { menuName: '被封禁用户', menuCode: 'comments-banned-users' } },
      { path: 'comments/keywords', name: 'CommentsKeywords', component: CommentsKeywords, meta: { menuName: '关键词管理', menuCode: 'comments-keywords' } },
      { path: 'traffic/categories', name: 'TrafficCategories', component: TrafficCategories, meta: { menuName: '分类管理', menuCode: 'traffic-categories' } },
      { path: 'traffic/products', name: 'TrafficProducts', component: TrafficProducts, meta: { menuName: '商品列表', menuCode: 'traffic-products' } },
      { path: 'traffic/promotion', name: 'TrafficPromotion', component: TrafficPromotion, meta: { menuName: '投流管理', menuCode: 'traffic-promotion' } },
      { path: 'agents/commission', name: 'AgentsCommission', component: AgentsCommission, meta: { menuName: '佣金规则', menuCode: 'agents-commission' } },
      { path: 'agents/applications', name: 'AgentsApplications', component: AgentsApplications, meta: { menuName: '申请记录', menuCode: 'agents-applications' } },
      { path: 'agents/list', name: 'AgentsList', component: AgentsList, meta: { menuName: '代理商', menuCode: 'agents-agents-list' } },
      { path: 'agents/withdrawal', name: 'AgentsWithdrawal', component: AgentsWithdrawal, meta: { menuName: '提现申请', menuCode: 'agents-withdrawal' } },
      { path: 'agents/earnings', name: 'AgentsEarnings', component: AgentsEarnings, meta: { menuName: '收益记录', menuCode: 'agents-earnings' } },
      { path: 'invoices', name: 'Invoices', component: AdminInvoices, meta: { menuName: '用户开票', menuCode: 'invoices' } },
      { path: 'channel', redirect: '/hq/board' },
      { path: 'channel/board', redirect: '/hq/board' },
      { path: 'channel/partners', redirect: '/hq/partners' },
      { path: 'channel/accounts', redirect: '/hq/accounts' },
      { path: 'channel/wallet', redirect: '/hq/wallet' },
      { path: 'channel/settlements', redirect: '/hq/settlements' },
      { path: 'channel/deposit', redirect: '/hq/deposits' },
      { path: 'channel/vouchers', redirect: '/hq/vouchers' },
      { path: 'channel/policies', redirect: '/hq/policies' },
      { path: 'channel/contracts', redirect: '/hq/agreements' },
      { path: 'channel/training', redirect: '/hq/training' },
      { path: 'channel/reports', redirect: '/hq/reports' },
      { path: 'channel/stats', redirect: '/hq/stats' },
      { path: 'channel/alerts', redirect: '/hq/alerts' },
      { path: 'settings', name: 'Settings', component: AdminSettings, meta: { menuName: '系统设置', menuCode: 'settings' } },
      { path: 'system/admins', name: 'SystemAdmins', component: SystemAdmins, meta: { menuName: '管理员', menuCode: 'system-admins' } },
      { path: 'system/roles', name: 'SystemRoles', component: SystemRoles, meta: { menuName: '角色管理', menuCode: 'system-roles' } },
      { path: 'system/menus', name: 'SystemMenus', component: SystemMenus, meta: { menuName: '菜单管理', menuCode: 'system-menus' } },
      { path: 'system/notices', name: 'SystemNotices', component: SystemNotices, meta: { menuName: '系统通知', menuCode: 'system-notices' } },
      { path: 'system/operation-logs', name: 'OperationLogs', component: OperationLogs, meta: { menuName: '操作日志', menuCode: 'system-operation-logs' } }
    ]
  },
  {
    path: '/hq',
    component: HqLayout,
    meta: { requiresAdmin: true },
    redirect: '/hq/board',
    children: [
      { path: 'board', name: 'HqBoard', component: HqBoard, meta: { menuName: '工作台看板', menuCode: 'hq-ch-board' } },
      { path: 'stats', name: 'HqStats', component: HqStats, meta: { menuName: '渠道统计', menuCode: 'hq-ch-stats' } },
      { path: 'partners', name: 'HqPartners', component: HqPartners, meta: { menuName: '渠道管理', menuCode: 'hq-ch-partners' } },
      { path: 'accounts', name: 'HqAccounts', component: HqAccounts, meta: { menuName: '渠道账号', menuCode: 'hq-ch-accounts' } },
      { path: 'wallet', name: 'HqWallet', component: HqWallet, meta: { menuName: '资金与积分账户', menuCode: 'hq-ch-wallet' } },
      { path: 'eco-recharges', name: 'HqEcoRecharges', component: HqEcoRecharges, meta: { menuName: '生态充值审核', menuCode: 'hq-ch-eco-recharge' } },
      { path: 'settlements', name: 'HqSettlements', component: HqSettlements, meta: { menuName: '分账结算', menuCode: 'hq-ch-settle' } },
      { path: 'deposits', name: 'HqDeposits', component: HqDeposits, meta: { menuName: '保证金管理', menuCode: 'hq-ch-deposit' } },
      { path: 'vouchers', name: 'HqVouchers', component: HqVouchers, meta: { menuName: '代金券管理', menuCode: 'hq-ch-voucher' } },
      { path: 'point-recharges', name: 'HqPointRecharges', component: HqPointRecharges, meta: { menuName: '积分充值清单', menuCode: 'hq-ch-point-recharge' } },
      { path: 'policies', name: 'HqPolicies', component: HqPolicies, meta: { menuName: '政策配置', menuCode: 'hq-ch-policy' } },
      { path: 'agreements', name: 'HqAgreements', component: HqAgreements, meta: { menuName: '协议管理', menuCode: 'hq-ch-contract' } },
      { path: 'training', name: 'HqTraining', component: HqTraining, meta: { menuName: '培训管理', menuCode: 'hq-ch-training' } },
      { path: 'reports', name: 'HqReports', component: HqReports, meta: { menuName: '报备审核', menuCode: 'hq-ch-report' } },
      { path: 'profile-changes', name: 'HqProfileChanges', component: HqProfileChanges, meta: { menuName: '资料变更审核', menuCode: 'hq-ch-profile' } },
      { path: 'alerts', name: 'HqAlerts', component: HqAlerts, meta: { menuName: '订单预警', menuCode: 'hq-ch-alert' } }
    ]
  },
  {
    path: '/partner',
    component: PartnerLayout,
    meta: { requiresAdmin: true },
    redirect: '/partner/board',
    children: [
      { path: 'board', name: 'PartnerBoard', component: PartnerBoard, meta: { menuName: '我的看板', menuCode: 'ch-board' } },
      { path: 'vouchers', name: 'PartnerVouchers', component: PartnerVouchers, meta: { menuName: '我的卡券', menuCode: 'ch-voucher' } },
      { path: 'recharge', name: 'PartnerRecharge', component: PartnerRecharge, meta: { menuName: '代金券管理', menuCode: 'ch-recharge' } },
      { path: 'eco', name: 'PartnerEco', component: PartnerEco, meta: { menuName: '购买积分', menuCode: 'ch-eco' } },
      { path: 'members', name: 'PartnerMembers', component: PartnerMembers, meta: { menuName: '名下会员', menuCode: 'ch-members' } },
      { path: 'works', name: 'PartnerWorks', component: PartnerWorks, meta: { menuName: '数据资产', menuCode: 'ch-works' } },
      { path: 'assets', redirect: '/partner/board' },
      { path: 'lines', name: 'PartnerLines', component: PartnerLines, meta: { menuName: '分账明细', menuCode: 'ch-lines' } },
      { path: 'statements', name: 'PartnerStatements', component: PartnerStatements, meta: { menuName: '对账单', menuCode: 'ch-statement' } },
      { path: 'withdraw', name: 'PartnerWithdraw', component: PartnerWithdraw, meta: { menuName: '提现管理', menuCode: 'ch-withdraw' } },
      { path: 'downline', name: 'PartnerDownline', component: PartnerDownline, meta: { menuName: '下级管理', menuCode: 'ch-downline' } },
      { path: 'reports', name: 'PartnerReports', component: PartnerReports, meta: { menuName: '客户报备', menuCode: 'ch-report' } },
      { path: 'training', name: 'PartnerTraining', component: PartnerTraining, meta: { menuName: '培训中心', menuCode: 'ch-training' } },
      { path: 'compliance', name: 'PartnerCompliance', component: PartnerCompliance, meta: { menuName: '协议与保证金', menuCode: 'ch-compliance' } },
      { path: 'profile', name: 'PartnerProfile', component: PartnerProfile, meta: { menuName: '个人信息', menuCode: 'ch-profile' } },
      { path: 'staff', name: 'PartnerStaff', component: PartnerStaff, meta: { menuName: '子账号管理', menuCode: 'ch-staff' } },
      { path: 'notices', name: 'PartnerNotices', component: PartnerNotices, meta: { menuName: '系统通知', menuCode: 'ch-notice' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

function flattenMenus(list) {
  const result = []
  if (!list || !list.length) return result
  list.forEach(item => {
    if (!item) return
    result.push(item)
    if (item.children && item.children.length) {
      result.push(...flattenMenus(item.children))
    }
  })
  return result
}

function isChannelUser() {
  const info = store.state.adminInfo || {}
  const roles = info.roleCodes || []
  return roles.indexOf('CHANNEL') >= 0 && roles.indexOf('SUPER_ADMIN') < 0
}

function homePath() {
  return isChannelUser() ? '/partner/board' : '/admin/dashboard'
}

function menuAllows(to, menus) {
  const code = to.meta && to.meta.menuCode
  return menus.some(menu => {
    if (!menu) return false
    if (code && menu.menuCode === code) return true
    if (menu.path && (menu.path === to.path || to.path.indexOf(menu.path + '/') === 0)) return true
    // 升级前的「渠道分账」菜单码仍可进入总部渠道页
    if (code && code.indexOf('hq-ch-') === 0 && menu.menuCode === 'channel') return true
    return false
  })
}

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters.isAdminLoggedIn
  // vue-router 的 to.meta 只取最后一层记录，requiresAdmin 声明在父路由上，需沿 matched 向上查找
  const requiresAdmin = to.matched.some(record => record.meta && record.meta.requiresAdmin)

  if (to.meta.adminGuest) {
    next(loggedIn ? homePath() : undefined)
    return
  }

  if (requiresAdmin && !loggedIn) {
    next({ path: '/admin/login', query: { redirect: to.fullPath } })
    return
  }

  if (requiresAdmin && loggedIn && isChannelUser()) {
    if (!to.path.startsWith('/partner')) {
      next('/partner/board')
      return
    }
    next()
    return
  }

  // 路由若声明了 meta.menuCode，则结合用户菜单做权限校验
  if (requiresAdmin && to.meta.menuCode && loggedIn) {
    const userMenus = flattenMenus(store.state.adminMenus || [])
    if (userMenus.length > 0 && !menuAllows(to, userMenus)) {
      const fallback = userMenus.find(m => m.path && (m.path.startsWith('/partner/') || m.path.startsWith('/admin/')))
      if (!fallback || fallback.path === to.path || fallback.path === from.path) {
        next(false)
        return
      }
      next({ path: fallback.path })
      return
    }
  }

  next()
})

export default router
